import React from 'react';

export const serviceData = {
  mobile: {
    title: "Mobile Development",
    icon: <i className="fas fa-mobile-alt"></i>,
    description: "Transform your business with cutting-edge mobile solutions. Our expert team delivers enterprise-grade applications that combine stunning design with AI-driven functionality. From native apps to agent-enabled cross-platform solutions, we ensure your mobile presence drives real business value and exceptional user experiences.",
    features: [
      "Native iOS & Android Development",
      "Cross-Platform Solutions (React Native, Flutter)",
      "AI-Powered UI/UX Design & Prototyping",
      "API Integration & Backend Services",
      "Agent-Enabled Push Notifications & Personalization",
      "App Store Optimization",
      "Maintenance & Support"
    ],
    benefits: [
      "Increased customer engagement and retention",
      "Enhanced brand visibility in mobile markets",
      "Streamlined business processes through AI-driven mobile automation",
      "Real-time data access and intelligent analytics",
      "Competitive advantage in digital marketplace"
    ]
  },
  
  web: {
    title: "Web Development",
    icon: <i className="fas fa-laptop-code"></i>,
    description: "Launch your digital presence with our enterprise-ready web development services. We build scalable, AI-enhanced web applications that grow with your business. Our prompt-engineered solutions combine modern architecture with robust security, ensuring your platform delivers consistent value to your customers.",
    features: [
      "Custom Web Application Development",
      "E-commerce & CMS Solutions",
      "Progressive Web Apps (PWA)",
      "Prompt-Engineered AI Chatbots & Assistants",
      "API Development & Integration",
      "Cloud Deployment & DevOps",
      "SEO & Performance Optimization"
    ],
    benefits: [
      "Enhanced online presence and brand credibility",
      "Improved customer acquisition and conversion through AI personalization",
      "Scalable solutions that grow with your business",
      "Mobile-responsive design for all devices",
      "Advanced security and data protection"
    ]
  },

  quickbooks: {
    title: "QuickBooks Support",
    icon: <i className="fas fa-university"></i>,
    description: "Streamline your financial operations with our comprehensive QuickBooks expertise. Our certified consultants provide end-to-end support for setup, optimization, and AI-assisted troubleshooting. We ensure your financial systems run smoothly, allowing you to focus on growing your business.",
    features: [
      "QuickBooks Setup & Configuration",
      "Data Migration & Cleanup",
      "AI-Assisted Custom Reporting & Dashboards",
      "Integration with Third-party Apps",
      "Training & User Support",
      "Ongoing Maintenance & Updates"
    ],
    benefits: [
      "Improved financial accuracy and compliance",
      "Time savings through AI-automated processes",
      "Better financial insights and intelligent reporting",
      "Reduced accounting errors and discrepancies",
      "Enhanced productivity for your finance team"
    ]
  },

  iaas: {
    title: "Infrastructure as a Service (IaaS)",
    icon: <i className="fas fa-cloud"></i>,
    description: "Leverage the power of Infrastructure as a Service with our enterprise-grade, AI-ready cloud solutions. We design, implement, and manage scalable infrastructure that adapts to your business needs. Our IaaS solutions provide the flexibility and reliability your organization needs to focus on growing your business.",
    features: [
      "Cloud Infrastructure Design & Setup",
      "Scalable Computing Resources",
      "AI-Ready GPU & Compute Provisioning",
      "Storage & Backup Solutions",
      "Network Configuration & Security",
      "Intelligent Monitoring & Performance Optimization",
      "24/7 Technical Support"
    ],
    benefits: [
      "Reduced capital expenditure on hardware",
      "Flexible scaling based on demand",
      "Infrastructure ready for AI and machine learning workloads",
      "Enhanced disaster recovery capabilities",
      "Improved system reliability and uptime"
    ]
  },

  cloud: {
    title: "Enterprise Cloud",
    icon: <i className="fas fa-server"></i>,
    description: "Accelerate your digital transformation with our comprehensive enterprise cloud services. We architect and deploy robust, agent-enabled cloud solutions that enhance operational efficiency, reduce costs, and drive AI-powered innovation. Our expertise ensures seamless migration and continuous optimization of your cloud environment.",
    features: [
      "Cloud Strategy & Planning",
      "Multi-cloud & Hybrid Solutions",
      "Cloud Migration Services",
      "Agent-Enabled DevOps & Automation",
      "AI Workload Orchestration",
      "Security & Compliance",
      "Cost Optimization & Management"
    ],
    benefits: [
      "Reduced operational costs and complexity",
      "Improved agility and time-to-market",
      "Enhanced security and compliance posture",
      "AI-driven insights for better collaboration and remote work",
      "Scalable resources that adapt to business needs"
    ]
  },

  desktop: {
    title: "Desktop Support",
    icon: <i className="fas fa-desktop"></i>,
    description: "Maximize productivity with our responsive, AI-augmented desktop support services. Our experienced team uses intelligent diagnostics to provide rapid resolution for all your technical challenges, ensuring minimal downtime and optimal performance. We keep your systems running smoothly so you can focus on growing your business.",
    features: [
      "Hardware & Software Troubleshooting",
      "Operating System Support",
      "Software Installation & Configuration",
      "AI-Assisted Diagnostics & Remote Support",
      "Remote & On-site Support",
      "Preventive Maintenance",
      "User Training & Documentation"
    ],
    benefits: [
      "Minimized system downtime through AI-powered early detection",
      "Improved employee productivity and satisfaction",
      "Proactive issue prevention and resolution",
      "Cost-effective IT support solutions",
      "Access to expert technical knowledge"
    ]
  }
};
